/**
 * @generated SignedSource<<56a217a14d49278565bc746184e7b1b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeriesSwitcher_ExternalStreamTooltip_stream$data = {
  readonly account: {
    readonly name: string;
  };
  readonly id: string;
  readonly isExternal: boolean;
  readonly relatedStreams: ReadonlyArray<{
    readonly account: {
      readonly name: string;
    };
    readonly id: string;
    readonly isExternal: boolean;
  }>;
  readonly " $fragmentType": "SeriesSwitcher_ExternalStreamTooltip_stream";
};
export type SeriesSwitcher_ExternalStreamTooltip_stream$key = {
  readonly " $data"?: SeriesSwitcher_ExternalStreamTooltip_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesSwitcher_ExternalStreamTooltip_stream">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "account",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesSwitcher_ExternalStreamTooltip_stream",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "relatedStreams",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "3be8ddfa3462b881fb786c5af887cfed";

export default node;
